/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Text, Modal } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';

import { getConfig } from 'blb-utils/config';
import { ModalContent } from 'blb-components/ModalContent';
import { getSupportEmailAnchor } from 'blb-utils/contact';

export const styles = StyleSheet.create({
  textBlock: {
    marginBottom: 8,
  },
});
export namespace SigninHelpModal {
  export interface Props {
    handleClose: () => void;
    isOpen: boolean;
  }
}
export const SigninHelpModal: React.FC<SigninHelpModal.Props> = ({ isOpen, handleClose }) => {
  return (
    <Modal contentLabel="Signin help" handleClose={handleClose} isOpen={isOpen}>
      <ModalContent handleClose={handleClose} headerText="Trouble signing in?">
        <p className={css(styles.textBlock)}>
          <Text>
            If this is your first time accessing Workspace, you will need to enter the Temporary Password you received
            via email in the Password line.
          </Text>
        </p>

        <p className={css(styles.textBlock)}>
          <Text>
            If you cannot find the Temporary Password email, use <Link to="/forgot-password">Forgot Password</Link> on
            the login screen to send yourself a new Temporary Password email.
          </Text>
        </p>
        <p>
          <Text>If you are unable to log in, contact {getSupportEmailAnchor(getConfig().supportEmail.default)}.</Text>
        </p>
      </ModalContent>
    </Modal>
  );
};

SigninHelpModal.displayName = 'SigninHelpModal';
